import * as actionTypes from '../actions/actionTypes'
import moment from "moment/moment";


const initialState = {
    plan_hours: [
        { key: 7, id: 7, label: '07:00', start: '07:00', shown: true },
        { key: 7.5, id: 7.5, label: '07:30', start: '07:30', shown: false },
        { key: 8, id: 8, label: '08:00', start: '08:00', shown: true },
        { key: 8.5, id: 8.5, label: '08:30', start: '08:30', shown: false },
        { key: 9, id: 9, label: '09:00', start: '09:00', shown: true },
        { key: 9.5, id: 9.5, label: '09:30', start: '09:30', shown: false },
        { key: 10, id: 10, label: '10:00', start: '10:00', shown: true },
        { key: 10.5, id: 10.5, label: '10:30', start: '10:30', shown: false },
        { key: 11, id: 11, label: '11:00', start: '11:00', shown: true },
        { key: 11.5, id: 11.5, label: '11:30', start: '11:30', shown: false },
        { key: 12, id: 12, label: '12:00', start: '12:00', shown: true },
        { key: 12.5, id: 12.5, label: '12:30', start: '12:30', shown: false },
        { key: 13, id: 13, label: '13:00', start: '13:00', shown: true },
        { key: 13.5, id: 13.5, label: '13:30', start: '13:30', shown: false },
        { key: 14, id: 14, label: '14:00', start: '14:00', shown: true },
        { key: 14.5, id: 14.5, label: '14:30', start: '14:30', shown: false },
        { key: 15, id: 15, label: '15:00', start: '15:00', shown: true },
        { key: 15.5, id: 15.5, label: '15:30', start: '15:30', shown: false },
        { key: 16, id: 16, label: '16:00', start: '16:00', shown: true },
        { key: 16.5, id: 16.5, label: '16:30', start: '16:30', shown: false },
        { key: 17, id: 17, label: '17:00', start: '17:00', shown: true },
        { key: 17.5, id: 17.5, label: '17:30', start: '17:30', shown: false },
        { key: 18, id: 18, label: '18:00', start: '18:00', shown: true },
        { key: 18.5, id: 18.5, label: '18:30', start: '18:30', shown: false },
        { key: 19, id: 19, label: '19:00', start: '19:00', shown: true },
        { key: 19.5, id: 19.5, label: '19:30', start: '19:30', shown: false },
        { key: 20, id: 20, label: '20:00', start: '20:00', shown: true }
    ],
    therapists: [],
    therapists_loaded: false,
    visits: {},
    conflicted_terms: [],
    visits_loaded: false,
    selectedBaseDate: new Date(),
    term_off_reasons: [
        { key: 'vacation', label: 'Urlop' },
        { key: 'blocked', label: 'Termin zablokowany' },
    ],
    periods: [
        { id: '604800', label: 'Co tydzień' },
        { id: '86400', label: 'Codziennie' },
    ],
    app_state: {
        user_is_logged_in: true,
        add_new_term_opened: false,
        add_new_term_edit_mode: false,
        current_visit: null,
        current_hour: null,
        selected_cell: null,
    },
    response_error_message: '',

};

const therapiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOGOUT:
            return {
                ...state,
                app_state: {
                    ...state.app_state,
                    user_is_logged_in: false
                }
            };

        case actionTypes.CANCEL_VISIT:
            return {
                ...state,
            };
        case actionTypes.SAVE_THERAPY:
            return {
                ...state
            };

        // NEW APPROACH
        case actionTypes.LOAD_THERAPISTS_SUCCEED:
            return {
                ...state,
                therapists: action.payload,
                therapists_loaded: true
            };

        case actionTypes.ADD_NEW_VISIT:
            return {
                ...state,
                app_state: {
                    ...state.app_state,
                    selected_cell: action.payload,
                    add_new_term_opened: true,
                    add_new_term_edit_mode: true,
                }
            };

        case actionTypes.SHOW_VISIT_DETAILS:
            return {
                ...state,
                app_state: {
                    ...state.app_state,
                    add_new_term_opened: true,
                    add_new_term_edit_mode: false,
                    selected_cell: action.payload,
                    current_visit: action.payload.get_visit()
                }
            };
        case actionTypes.HIDE_VISIT_DETAILS:
            return {
                ...state,
                app_state: {
                    ...state.app_state,
                    add_new_term_opened: false,
                    current_visit: null,
                    current_hour: null
                },
            };

        case actionTypes.CHANGE_CALENDAR_DATE:
            const new_date = moment(state.selectedBaseDate).add(action.payload, 'days').toDate();
            return {
                ...state,
                selectedBaseDate: new_date
            };

        case actionTypes.SET_CALENDAR_DATE:
            return {
                ...state,
                selectedBaseDate: action.payload
            };

        case actionTypes.LOAD_VISITS_SUCCEED:
            return {
                ...state,
                visits: action.payload,
                visits_loaded: true
            };
        case actionTypes.SET_ERROR_MESSAGE:
            return {
                ...state,
                response_error_message: action.payload
            };
        case actionTypes.SET_CONFLICTED_TERMS:
            return {
                ...state,
                conflicted_terms: action.payload
            };

        default:
            return state
    }
};

export default therapiesReducer


// WEBPACK FOOTER //
// ./src/store/reducers/therapies.js